import React from "react";

import { Grid } from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import DoneIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Cancel';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import Style from "../../../../styles/js/Styles";
import * as Constants from "../../../../consts/Constants.js";

import Details from "./details";
import Contact from "./contact";
import Location from "./location";
import Schedule from "./schedule";
import Photos from "./photos";

import { Place } from '../../../../plas/map/places/models';
import service from '../../../../plas/map/places/service';
import alerter from "../../../alerts/alerter"

export default function PlaceCreationForm({ 
	placeId, 
	rootCategory, 
	onCancel, 
	onSave, 
	fullWidth, 
	initialPlace,
	options = {}
}) {

	const theme = createTheme({
	  palette: {
	    primary: {
	      main: '#FFFFFF',
	      darker: '#FFFFFF',
	    }
	  },
	});

	const style = Style();

	const [saving, setSaving] = React.useState(false);
	const [loadingPlace, setLoadingPlace] = React.useState(true);
	const [loadingCategories, setLoadingCategories] = React.useState(true);

	const [place, setPlace] = React.useState(null);
	const [canSave, setCanSave] = React.useState(false);
  	const [categories, setCategories] = React.useState(null);

	React.useEffect(() => {
		loadCategories(rootCategory)
		if (placeId) {
			loadPlace(placeId);
		} else {
			setPlace(initialPlace ? initialPlace : new Place());
			setLoadingPlace(false);
		}
	}, []);

	const loadPlace = (placeId) => {
		service.api.places.get(placeId,(response) => {
			if (response.error != null) {
        		alerter.showError(response.error);
        		if (onCancel)
        			onCancel()
			} else {
				setPlace(response.result);
				setCanSave(response.result.isValid());
				setLoadingPlace(false);
			}
		});
	}

	const loadCategories = (rootCategory) => {
		service.api.categories.get(rootCategory, true, (response) => {
			if (response.error != null) {
        		alerter.showError(response.error);
        		if (onCancel)
        			onCancel()
			} else {
				let allCategories = response.result.all();
				allCategories.forEach((item) => {item.label = item.name});
				setCategories(allCategories);
				setLoadingCategories(false);
			}
		});
	}

	const saveHandler = () => {
		if (place.id) {
			update()
		} else {
			create();
		}
	}

  	const create = () => {
  		setSaving(true)
  		service.api.places.create(place, (response) => {
  			if (response.result != null) {
  				if (onSave)
  					onSave(response.result);
  			} else {
  				alerter.showError(response.error);
  			}
			setSaving(false)
  		});
	}

	const update = () => {
  		setSaving(true)
  		service.api.places.update(place, (response) => {
  			if (response.result != null) {
  				if (onSave)
  					onSave(response.result);
  			} else {
  				alerter.showError(response.error);
  			}
			setSaving(false)
  		});
	}

	const onChange = () => {
		setCanSave(place ? place.isValid() : false)
	}

  	const ColoredLine = ({ color }) => (
	    <hr
	        style={{
	            color: color,
	            backgroundColor: color,
	            marginTop: 6,
	            marginBottom: 16,
	            height: 2
	        }}
	    />
	);

	return(
   		<div className={style.box} >
   		{ loadingPlace || loadingCategories ?
	        (
	          <div style={{color:Constants.COLOR_PRIMARY}}>
	            <CircularProgress color="inherit" />
	          </div>
	        ) : 
	        (
        	  <Grid container style={{ paddingBottom: '16px' }}>
             	<Grid item xs={false} md={ fullWidth ? false : 2} />
             	<Grid item xs={12} md={ fullWidth ? 12 : 8} >
					<Grid container spacing={2}>
						<Grid item xs={12}>
						  <p style={{ fontSize: '28px', textAlign: 'left'}}>
				            Datos del lugar
				          </p>
				          <ColoredLine color="gray"/>
						</Grid>
	             		<Grid item xs={12} >
		                 	<Details place={place} categories={categories} disable={saving} onChange={onChange} options={options.details} />
		                </Grid>
	                </Grid>
	                { options.photos !== 'hidden' ? (
		                <Grid container spacing={2} >
							<Grid item xs={12}>
								<p style={{ fontSize: '28px', textAlign: 'left', marginTop: '16px'}}>
						            Fotos
						        </p>
					        	<ColoredLine color="gray"/>
							</Grid>
					       	<Grid item xs={12} >
					        	<Photos place={place} disable={saving} />
							</Grid>
						</Grid>): (null)
	                }
	                <Grid container spacing={2} >
						<Grid item xs={12}>
							<p style={{ fontSize: '28px', textAlign: 'left', marginTop: '16px'}}>
					            Ubicación
					        </p>
				        	<ColoredLine color="gray"/>
						</Grid>
				       	<Grid item xs={12} >
				        	<Location place={place} disable={saving} onChange={onChange}/>
						</Grid>
					</Grid>
			       	<Grid container spacing={2} >
						<Grid item xs={12}>
							<p style={{ fontSize: '28px', textAlign: 'left', marginTop: '16px'}}>
					            Contacto
					        </p>
				        	<ColoredLine color="gray"/>
						</Grid>
						<Grid item xs={12} >
			        		<Contact place={place} disable={saving} onChange={onChange} options={options.contact} />
			        	</Grid>
					</Grid> 
					{ options.schedule !== 'hidden' ? (
						<Grid container spacing={2} >
							<Grid item xs={12}>
								<p style={{ fontSize: '28px', textAlign: 'left', marginTop: '16px'}}>
						            Horarios
						        </p>
					        	<ColoredLine color="gray"/>
					        </Grid>
					        <Grid item xs={12} >
				        		<Schedule place={place} disable={saving} />
				        	</Grid>
						</Grid>) : (null)
					}
					{ onCancel || onSave ? (
						<Grid container spacing={2} >
							<Grid item xs={12}>
								<ColoredLine color="gray"/>
								<Grid container spacing={2}>
									<Grid item xs={true}/>
									<Grid item>
										{ onCancel? (
											<ThemeProvider theme={theme}>
												<Button 
									            	startIcon={<CancelIcon/>} 
									            	variant="contained" 
									            	onClick={() => onCancel()}>
									            	Cancelar
									            </Button>
									        </ThemeProvider>) : (null)
								        }
									</Grid>
									<Grid item>
										{ onSave ? (
											<LoadingButton
												disabled={!canSave}
									            loadingPosition="start"
									            startIcon={<DoneIcon />}
									            loading={saving}
									            variant="contained"
									            onClick={saveHandler}>
									            <b>{ place.id ? "Guardar" : "Crear" }</b>
							          		</LoadingButton>) : (null)
						          		}
									</Grid>
								</Grid>
				    		</Grid>
						</Grid>) : (null)
					}
             	</Grid>
             	<Grid item xs={false} md={ fullWidth ? false : 2} />
	    	  </Grid>
		    )
		}
		</div>
	)

}